//to resolve sonar duplicate code errors
import React, { useEffect } from 'react';
import type { MessageDescriptor } from 'react-intl-next';
import { FormattedMessage } from 'react-intl-next';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import AutomationLight from './images/Automation-Light.svg';
import AutomationDark from './images/Automation-Dark.svg';
import type { OnboardingSlide } from './OnboardingModal';

export const getAutomationSlide = (
	title: MessageDescriptor,
	body: MessageDescriptor,
	userPrivilege: 'siteAdmin' | 'user',
) => {
	return {
		title: <FormattedMessage {...title} />,
		body: <AutomationSlideBody body={body} userPrivilege={userPrivilege} />,
		imageUrlLight: AutomationLight,
		imageUrlDark: AutomationDark,
	} as OnboardingSlide;
};

type AutomationSlideBodyProp = {
	body: MessageDescriptor;
	userPrivilege: 'siteAdmin' | 'user';
};

const AutomationSlideBody = ({ body, userPrivilege }: AutomationSlideBodyProp) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	useEffect(() => {
		createAnalyticsEvent({
			type: 'sendScreenEvent',
			data: {
				name: 'automationPremiumOnboarding',
				attributes: {
					userPrivilege: `${userPrivilege}`,
				},
			},
		}).fire();
	}, [createAnalyticsEvent, userPrivilege]);

	const handleOnClick = () => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'link',
				actionSubjectId: 'automationPremiumOnboarding',
				attributes: {
					userPrivilege: `${userPrivilege}`,
				},
			},
		}).fire();
	};

	return (
		<FormattedMessage
			{...body}
			values={{
				automationLink: (chunks: React.ReactNode[]) => (
					<a
						href="https://support.atlassian.com/confluence-cloud/docs/what-is-confluence-automation/"
						target="_blank"
						onClick={handleOnClick}
					>
						{chunks}
					</a>
				),
			}}
		/>
	);
};
